import * as React from "react";

export const DisplayContext = React.createContext<{ 
    darkMode: boolean;
    changeTheme: (dark?: boolean) => void;
}>(undefined);